import axiosInstance from 'utils/axiosInstance';

export type ClientPhoneData = {
  mobilePhone: string;
  status: string;
};

export default async function getClientPhone() {
  return (await axiosInstance.get<ClientPhoneData>('/client/phone')).data;
}
